import { render, staticRenderFns } from "./ConfirmModalIcon.vue?vue&type=template&id=06bc9bf0&scoped=true"
import script from "./ConfirmModalIcon.vue?vue&type=script&lang=js"
export * from "./ConfirmModalIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bc9bf0",
  null
  
)

export default component.exports